import Request from 'gd-request';

class ApiTaskType {

    constructor() {

    }

    setTaskTypeNameIcon(taskTypeId, organizationId, name, icon) {
        return new Request(this,'put','company/'+organizationId+'/task-type/'+taskTypeId,{
            name: name,
            icon: icon,
        });
    }

    setTaskTypeSettings(taskTypeId, organizationId, settings) {
        return new Request(this, 'PUT', 'company/'+organizationId+'/task-type/'+taskTypeId+'/settings', {
            settings: settings
        });
    }
}

module.exports = ApiTaskType;